import React, { useState } from "react";
import { Helmet } from "react-helmet";
import MPHButton from "src/components/actionPerformers/MPHButtons/MPHButton";
import MPHFooterPrimary from "src/components/actionPerformers/MPHFooterPrimary/MPHFooterPrimary";
import MPHFooterSecondary from "src/components/actionPerformers/MPHFooterSecondary/MPHFooterSecondary";
import MPHHeaderMain from "src/components/actionPerformers/MPHHeaderMain/MPHHeaderMain";
import MPHInput from "src/components/DataProviders/MPHInput";
import { useApiAxiosRequests } from '../../utils/ApiService/MPHApis';
import { BRAND_NAME, DEVICE_ID, INTERNAL_REDIRECTION_URLS } from "src/config/constants";
import "./PromotionScreen.scss";
import { useNavigate } from "react-router-dom";

const PromotionScreen = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [token, settoken] = useState("");
  const [sessionId, setSessionId] = useState("");
  const navigate = useNavigate();

  const {
    tokenGenerate,
    getCustomerByEmail
  } = useApiAxiosRequests();

  const navigateToPage = (redirect?: any) => {
    window.open(redirect, "_blank");
  };

  const tokenGenerateFunc = async () => {
    const payload = {
      identifierType: "EMAIL",
      identifierValue: email.toLowerCase(),
      deviceId: DEVICE_ID,
      brand: BRAND_NAME,
      password: "123",
      confirmPassword: "123",
    };
    setIsLoading(true);
    const res: any = await tokenGenerate(payload);
    setIsLoading(false);
    if (res.data && res.data.status && res.data.status.success) {
      settoken(res.data.auth.token);
      setSessionId(res.data.user.sessionId);
    }
    return {
      status: res.data && res.data.status && res.data.status.success,
      data: res.data,
    };
  };

  const getCustomerByEMailFunc = async (email: any, token: any) => {
    const data = await getCustomerByEmail({ email: email }, token);
    return data;
  };

  const verifyEmail = async () => {
    const tokenData = await tokenGenerateFunc();

    const data: any = await getCustomerByEMailFunc(
      email.toLowerCase(),
      tokenData?.data?.auth?.token
    );

    if (data && data.data.status.success === "true") {
      navigate(`/login?promotion=true&email=${email}`);
    } else {
      navigate(`/signup?promotion=true&email=${email}`);
    }
  }

  return (
    <>
      <Helmet>
        <title>Promotion Screen</title>
        <meta name="description" content="Promotion Screen" />
      </Helmet>
      <MPHHeaderMain active="/my-place-memories-promotion-enrollment" />
      <div className="margin-top">
        <div className="promotion-screen">
          <div className="input-width">
            <h4 style={{ textAlign: 'center' }}>My Place Memories Sweepstakes</h4>
            <div className="promotion-screen-content">
              Register for your chance to win one of three My Place Memories by
              entering your email address below.
            </div>
            <MPHInput
              placeholder="Enter Email"
              keyboardType={"email"}
              value={email}
              onChangeText={(text: any) => {
                setEmail(text);
              }}
            />
          </div>
          <div className="button-center">
            <MPHButton
              disabled={isLoading}
              isLoading={isLoading}
              buttonText="Submit"
              onbuttonClick={() => verifyEmail()}
            />
          </div>
          <span className="tc" onClick={() => {
            navigateToPage(INTERNAL_REDIRECTION_URLS.MPH_TERMS_AND_CONDITIONS);
          }}>Terms and conditions apply</span>
        </div>
        <MPHFooterPrimary />
        <MPHFooterSecondary />
      </div>
    </>
  );
};

export default PromotionScreen;
